export default {}.install = (Vue, options = {}) => {
  Vue.directive('preventReClick', {
    inserted(el, binding) {
      if (el.tagName === 'DIV') {
        el.addEventListener('click', e => {
          if (!el.disabled) {
            el.disabled = true
            el.style.cursor = 'not-allowed'
            setTimeout(() => {
              el.style.cursor = 'pointer'
              el.disabled = false
            }, binding.value || 1500)
          } else { // disabled为true时，阻止默认的@click事件
            e.preventDefault()
            e.stopPropagation()
          }
        }, true)
      } else {
        el.addEventListener('click', e => {
          if (!el.disabled) {
            el.disabled = true
            el.style.cursor = 'not-allowed'
            setTimeout(() => {
              el.style.cursor = 'pointer'
              el.disabled = false
            }, binding.value || 1500)
          }
        })
      }
    }
  })
}
